import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BookingPopup.css';

const BookingPopup = ({ isOpen, onClose, doctorId, doctorName = "Dr. Smith", consultationFee = 500 }) => {
    const navigate = useNavigate();
    const [bookingData, setBookingData] = useState({
        date: '',
        timeSlot: '',
        name: '',
        phone: '',
        reason: ''
    });
    const [loading, setLoading] = useState(false);

    // Get today's date in YYYY-MM-DD format for min date
    const today = new Date().toISOString().split('T')[0];
    
    // Get current time
    const getCurrentTime = () => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        return { hours, minutes };
    };

    // Generate time slots based on current time
    const getAvailableTimeSlots = (selectedDate) => {
        const allTimeSlots = [
            '09:00 AM', '09:30 AM', '10:00 AM', '10:30 AM',
            '11:00 AM', '11:30 AM', '12:00 PM', '12:30 PM',
            '02:00 PM', '02:30 PM', '03:00 PM', '03:30 PM',
            '04:00 PM', '04:30 PM', '05:00 PM', '05:30 PM'
        ];

        // If selected date is today, filter out past times
        if (selectedDate === today) {
            const now = new Date();
            const currentHours = now.getHours();
            const currentMinutes = now.getMinutes();
            const currentTimeInMinutes = currentHours * 60 + currentMinutes;
            
            return allTimeSlots.filter(slot => {
                const [time, period] = slot.split(' ');
                let [slotHours, slotMinutes] = time.split(':').map(Number);
                
                // Convert to 24-hour format
                if (period === 'PM' && slotHours !== 12) {
                    slotHours += 12;
                } else if (period === 'AM' && slotHours === 12) {
                    slotHours = 0;
                }
                
                const slotTimeInMinutes = slotHours * 60 + slotMinutes;
                
                // Show only slots that are at least 1 hour in the future
                return slotTimeInMinutes > (currentTimeInMinutes + 60);
            });
        }
        
        // If future date, show all time slots
        return allTimeSlots;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setBookingData(prev => ({
            ...prev,
            [name]: value
        }));
    };



    const handleBookingSubmit = (e) => {
        e.preventDefault();
        
        // Save booking data to localStorage
        localStorage.setItem('tempBookingData', JSON.stringify(bookingData));
        
        // Close the popup first
        onClose();
        
        // Navigate to checkout page
        navigate(`/checkout/${doctorId}`);
    };

    const handleClose = () => {
        console.log('Closing popup...');
        onClose();
    };



    if (!isOpen) return null;

    return (
        <div className="booking-popup-overlay" onClick={handleClose}>
            <div className="booking-popup" onClick={(e) => e.stopPropagation()}>
                <button onClick={handleClose} className="close-btn">×</button>
                
                <h2>Book Appointment</h2>
                <form onSubmit={handleBookingSubmit}>
                    <div className="form-group">
                        <label>Select Date:</label>
                        <input
                            type="date"
                            name="date"
                            value={bookingData.date}
                            onChange={handleInputChange}
                            min={today}
                            required
                        />
                    </div>
                    
                    {bookingData.date && (
                        <div className="form-group">
                            <label>Select Time:</label>
                            {getAvailableTimeSlots(bookingData.date).length > 0 ? (
                                <select
                                    name="timeSlot"
                                    value={bookingData.timeSlot}
                                    onChange={handleInputChange}
                                    required
                                >
                                    <option value="">Select a time slot</option>
                                    {getAvailableTimeSlots(bookingData.date).map((slot, index) => (
                                        <option key={index} value={slot}>{slot}</option>
                                    ))}
                                </select>
                            ) : (
                                <div style={{ 
                                    color: '#e74c3c', 
                                    fontSize: '14px', 
                                    padding: '10px',
                                    backgroundColor: '#fdf2f2',
                                    border: '1px solid #f5c6cb',
                                    borderRadius: '4px',
                                    marginTop: '5px'
                                }}>
                                    No available time slots for today. Please select a future date.
                                </div>
                            )}
                        </div>
                    )}

                    <div className="form-group">
                        <label>Your Name:</label>
                        <input
                            type="text"
                            name="name"
                            value={bookingData.name}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Phone Number:</label>
                        <input
                            type="tel"
                            name="phone"
                            value={bookingData.phone}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>Reason for Visit:</label>
                        <textarea
                            name="reason"
                            value={bookingData.reason}
                            onChange={handleInputChange}
                            
                        />
                    </div>

                    <button type="submit" className="submit-btn">Continue to Checkout</button>
                </form>
            </div>
        </div>
    );
};

export default BookingPopup;

                
